// extracted by mini-css-extract-plugin
export default {"hint":"Hint_hint__bXKIP","box":"Hint_box__3aW8B","title":"Hint_title__Irk6d","image":"Hint_image__5ShFL","text":"Hint_text__aniBm","flareAnimation":"Hint_flareAnimation__5M2UB"};